'use client';
import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Box } from './Box.js';
import { Text } from './Text.js';

const StyledContent = styled(TooltipPrimitive.Content, {
    backgroundColor: '$transparentPanel',
    borderRadius: '$1',
    padding: '$1 $2',
    zIndex: 9999,
    variants: {
        multiline: {
            true: {
                maxWidth: 250,
                pb: 7,
            },
        },
    },
});
function Tooltip(_a) {
    var { children, content, open, defaultOpen, onOpenChange, delayDuration, disableHoverableContent, multiline } = _a, props = __rest(_a, ["children", "content", "open", "defaultOpen", "onOpenChange", "delayDuration", "disableHoverableContent", "multiline"]);
    const rootProps = { open, defaultOpen, onOpenChange, delayDuration, disableHoverableContent };
    return (React.createElement(TooltipPrimitive.Root, Object.assign({}, rootProps),
        React.createElement(TooltipPrimitive.Trigger, { asChild: true }, children),
        React.createElement(TooltipPrimitive.Portal, null,
            React.createElement(StyledContent, Object.assign({ side: "top", align: "center", sideOffset: 5 }, props, { multiline: multiline }),
                React.createElement(Text, { size: "1", as: "p", variant: 'loContrast', css: {
                        color: '$loContrast',
                        lineHeight: multiline ? '20px' : undefined,
                    } }, content),
                React.createElement(Box, { css: { color: '$transparentExtreme' } },
                    React.createElement(TooltipPrimitive.Arrow, { width: 11, height: 5, style: { fill: 'currentColor' } }))))));
}

export { Tooltip };
